const toDecimal = (valor) =>{
    if((valor!=='')&&(valor!==undefined)){
        return(parseFloat(valor).toFixed(2));
    }else{
        return('0');
    }
}

const toBRL = (valor) => {
    if (valor !== '' && valor !== undefined && valor !== null) {
        const num = parseFloat(valor);
        if (isNaN(num)) return 'R$ 0,00';
        return num.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
    return 'R$ 0,00';
}

const toFloat = (valor,numCasas)=>{
    if((valor!=='')&&(valor!==undefined)){
        return(parseFloat(valor).toFixed(numCasas));
    }else{
        return('0');    
    }
}

export {toDecimal, toFloat, toBRL};